import script from "./videosSection.vue?vue&type=script&setup=true&lang=js"
export * from "./videosSection.vue?vue&type=script&setup=true&lang=js"

import "./videosSection.vue?vue&type=style&index=0&id=d8d95746&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8d95746"]])

export default __exports__